export default __webpack_public_path__ + "static/media/top-view-person-writing-laptop-with-copy-space.ae730e44.png";